import { FC, ReactNode, useMemo } from 'react';
import {
  ApolloProvider as ACApolloProvider,
  ApolloClient,
  InMemoryCache,
  HttpLink,
  from,
} from '@apollo/client';
import { useConfig } from '@/components/Providers/ConfigProvider/ConfigProvider';

const ApolloProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const { config } = useConfig();

  const client = useMemo(() => {
    const httpLink = new HttpLink({
      uri: config.apiBaseUrl,
    });

    return new ApolloClient({
      link: from([httpLink]),
      cache: new InMemoryCache(),
    });
  }, [config.apiBaseUrl]);

  return <ACApolloProvider client={client}>{children}</ACApolloProvider>;
};

export default ApolloProvider;
